// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Copy = function Copy(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M10.3 4.79H1.87a.74.74 0 00-.74.74V14a.74.74 0 00.74.74h8.43A.74.74 0 0011 14V5.53a.75.75 0 00-.7-.74zm-.74 8.43h-7v-7h7z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14 1H5.59a.74.74 0 00-.74.73v2.36h1.48V2.47h7v7h-1.59v1.47H14a.74.74 0 00.74-.73V1.72A.74.74 0 0014 1z"
    }))
  );
};

export default Copy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Copy.js
// module id = 994
// module chunks = 0